export default __webpack_public_path__ + "static/media/sonu.36b3b393.png";